// import React from "react";
// import { useNavigate } from "react-router-dom";
// import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";

// const ModuleSelectionPage = () => {
//   const navigate = useNavigate();

//   const handleNavigation = (module) => {
//     if (module === "recruitment") {
//       navigate("/summary_report");
//     } else if (module === "leave") {
//       navigate("/employee_leave_dashboard");
//     } else if (module === "metrics") {
//       navigate("/recruiter_performance");
//     }
//   };

//   const modules = [
//     {
//       key: "recruitment",
//       title: "Recruitment",
//       description:
//         "Manage job descriptions, screen profiles, and onboard candidates.",
//       icon: "fas fa-briefcase",
//       color: "text-primary",
//     },
//     {
//       key: "metrics",
//       title: "Recruiter Metrics",
//       description:
//         "Visualize recruiter performance, submissions, offers, and more.",
//       icon: "fas fa-chart-line",
//       color: "text-warning",
//     },
//     // {
//     //   key: "leave",
//     //   title: "Leave Management",
//     //   description: "Apply for leave, track balances, and view leave history.",
//     //   icon: "fas fa-calendar-check",
//     //   color: "text-success",
//     // },
//   ];

//   return (
//     <>
//       <NavbarForOnboardingForm />
//       <div
//         className="container-fluid bg-light main-content"
//         style={{
//           // background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
//           minHeight: "100vh",
//           paddingTop: "80px", // adjust this to match your navbar height
//         }}
//       >
//         <h2 className="mb-5 text-center font_header fw-bold">
//           🚀 Select a Module
//         </h2>

//         <div className="row justify-content-center g-4 px-4">
//           {modules.map((module) => (
//             <div className="col-sm-10 col-md-6 col-lg-4" key={module.key}>
//               <div
//                 className="card h-100 text-center border-0 shadow-lg rounded-4 p-3 module-card"
//                 onClick={() => handleNavigation(module.key)}
//                 style={{
//                   cursor: "pointer",
//                   transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                 }}
//                 onMouseEnter={(e) =>
//                   (e.currentTarget.style.transform = "scale(1.05)")
//                 }
//                 onMouseLeave={(e) =>
//                   (e.currentTarget.style.transform = "scale(1)")
//                 }
//               >
//                 <div className="card-body">
//                   <i
//                     className={`${module.icon} fa-3x mb-3 ${module.color}`}
//                   ></i>
//                   <h5 className="card-title fw-semibold">{module.title}</h5>
//                   <p className="card-text text-muted">{module.description}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default ModuleSelectionPage;

import React from "react";
import { useNavigate } from "react-router-dom";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";

const ModuleSelectionPage = () => {
  const navigate = useNavigate();

  const handleNavigation = (module) => {
    if (module === "recruitment") {
      navigate("/summary_report");
    } else if (module === "metrics") {
      navigate("/recruiter_performance");
    }
  };

  const modules = [
    {
      key: "recruitment",
      title: "Recruitment",
      description:
        "Manage job descriptions, screen profiles, and onboard candidates.",
      icon: "fas fa-briefcase",
      color: "#007bff", // Bootstrap primary
      bg: "rgba(0, 123, 255, 0.1)",
    },
    {
      key: "metrics",
      title: "Recruiter Metrics",
      description:
        "Visualize recruiter performance, submissions, offers, and more.",
      icon: "fas fa-chart-line",
      color: "#ffc107", // Bootstrap warning
      bg: "rgba(255, 193, 7, 0.1)",
    },
  ];

  return (
    <>
      <NavbarForOnboardingForm />
      <div
        className="container-fluid min-vh-100 d-flex align-items-center justify-content-center position-relative overflow-hidden"
        style={{
          background:
            "radial-gradient(circle at top left, #e3f2fd, #f8f9fa, #ffffff)",
          paddingTop: "80px",
        }}
      >
        {/* Decorative Background Circles */}
        <div
          className="position-absolute rounded-circle bg-primary opacity-10"
          style={{ width: "200px", height: "200px", top: "10%", left: "5%" }}
        />
        <div
          className="position-absolute rounded-circle bg-warning opacity-10"
          style={{
            width: "300px",
            height: "300px",
            bottom: "10%",
            right: "5%",
          }}
        />

        <div className="text-center mb-5">
          <h2 className="font_header fw-bold text-dark">
            🚀 Choose Your Module
          </h2>
          <p className="text-muted">Pick a workspace to get started quickly</p>
        </div>

        <div className="row w-100 justify-content-center px-4">
          {modules.map((module) => (
            <div className="col-md-5 col-lg-4 mb-4" key={module.key}>
              <div
                className="card glass-card p-4 border-0 shadow-lg text-center"
                onClick={() => handleNavigation(module.key)}
                style={{
                  cursor: "pointer",
                  background: module.bg,
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  borderRadius: "2rem",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div className="card-body">
                  <i
                    className={`${module.icon} fa-3x mb-3`}
                    style={{ color: module.color }}
                  ></i>
                  <h5 className="card-title fw-semibold">{module.title}</h5>
                  <p className="card-text text-muted">{module.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ModuleSelectionPage;
